import React, { useState } from "react";
import MenuAdmin from '../../../components/layout/menu';
import Select from 'react-select';
import Programate from "../../../components/layout/footer";

const Configuration = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const [empresa, setEmpresa] = useState("");
  const [planta, setPlanta] = useState('');
  const [caseta, setCaseta] = useState('');
  const [cargo, setCargo] = useState('');
  const [selectedOptionsRadios, setSelectedOptionsRadios] = useState([]);
 
  const options = [
    { value: 'empresa1', label: 'Colaborador 1' },
    { value: 'empresa2', label: 'Colaborador 2' },
    { value: 'empresa3', label: 'Colaborador 3' },
  ];

  const optionsPlanta = [
    { value: 'planta1', label: 'Planta A' },
    { value: 'planta2', label: 'Planta B' },
    { value: 'planta3', label: 'Planta C' },
  ];

  const optionsCaseta = [
    { value: 'caseta1', label: 'Caseta 1' },
    { value: 'caseta2', label: 'Caseta 2' },
    { value: 'caseta3', label: 'Caseta 3' },
  ];

  const optionsCargo = [
    { value: 'cargo1', label: 'Cargo 1' },
    { value: 'cargo2', label: 'Cargo 2' },
    { value: 'cargo3', label: 'Cargo 3' },
  ];

  const optionsRadios = [
    { value: 'Habilitar Lector QR', label: 'Habilitar Lector QR' },
    { value: 'Balanza de Pesaje', label: 'Balanza de Pesaje' },
    { value: 'Tablero', label: 'Tablero' },
    { value: 'Dashboard', label: 'Dashboard' }
  ];

  const handleChange = (selectedOption) => {
    setEmpresa(selectedOption ? selectedOption.value : '');
  };
  const handleChangePlanta = (selectedOption) => {
    setPlanta(selectedOption ? selectedOption.value : '');
  };

  const handleChangeCaseta = (selectedOption) => {
    setCaseta(selectedOption ? selectedOption.value : '');
  };

  const handleChangeCargo = (selectedOption) => {
    setCargo(selectedOption ? selectedOption.value : '');
  };

  const toggleOption = (value) => {
    if (selectedOptionsRadios.includes(value)) {
      setSelectedOptionsRadios(selectedOptionsRadios.filter(opt => opt !== value));
    } else {
      setSelectedOptionsRadios([...selectedOptionsRadios, value]);
    }
  };

  return (
    <div className="flex w-full min-h-screen">
      <MenuAdmin isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} className="transition-all duration-300" />
      <div className={`flex-1 transition-all duration-300 ml-0 ${isMenuOpen ? "lg:ml-[200px] sm:ml-[0] md:ml-[0]" : "ml-0"} w-[87%]`}>           
        <div className="flex flex-col justify-between min-h-screen">
          <div>
            <div className="pb-2  md:pt-40 pt-28 lg:pt-32 2xl:pt-28">
              <p className="text-[32px] font-itcbold text-[#007696] text-center lg:-ml-[61rem] xl:-ml-[36rem] 2xl:-ml-[52rem]">Generar Accesos</p>
            </div>
    
            <div className="px-[2%]">
              <p className="text-[24px] px-[4%] xl:px-[15%]  lg:px-[14%] 2xl:px-[13.5%] mt-5 2xl:mt-0 font-itcmedium text-[#007696] ">Roles</p>
              <div className="border-t border-[#808080] w-[372px] md:w-[753px] mx-auto my-4 xl:ml-[11.50rem] 2xl:ml-[12.80rem]"></div> 
            </div>
    
            <div className="px-[2%] lg:ml-[9.5rem] xl:ml-[9rem] 2xl:ml-[9.5rem]">
              <div className="flex items-center mt-8">
                <p className="px-[4%] text-[16px] font-itcbook text-[#111928] ">Escoger colaborador:</p>
                <Select
                  value={options.find(option => option.value === empresa)}
                  onChange={handleChange}
                  options={options}
                  placeholder="Nombre o DNI"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#76A140', 
                      borderRadius: '0.375rem', 
                      width: '17.188rem', 
                      height: 'full',
                      padding: '0.3rem 1.25rem 0.3rem 0.625rem', 
                      fontFamily: 'ITC Book, sans-serif',
                      fontSize: '0.875rem', 
                      backgroundColor: '#fff', 
                      appearance: 'none'
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      padding: '0rem', 
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2376A140'%3E%3Cpolygon points='12,16 6,8 18,8' /%3E%3C/svg%3E")`, 
                      backgroundSize: '1.5rem',
                      backgroundPosition: 'rigth 4rem',
                      backgroundRepeat: 'no-repeat',
                      border: 'none',
                      
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#6B7280', 
                    }),
                    indicatorSeparator: (base) => ({
                      backgroundColor: '#76A140', 
                      width: '1px', 
                      position: 'absolute',
                      left: '13.8rem', 
                      top: '0',
                      bottom: '0', 
                    }),
                  }}
                />
              </div>
    
              <div className="flex items-center mt-4">
                <p className="px-[4%] text-[16px] font-itcbook text-[#111928] ">Planta:</p>
                <Select
                  value={optionsPlanta.find(option => option.value === planta)}
                  onChange={handleChangePlanta}
                  options={optionsPlanta}
                  placeholder="Seleccione"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#76A140',
                      borderRadius: '0.375rem', 
                      width: '17.188rem', 
                      height: 'full',
                      padding: '0.3rem 1.25rem 0.3rem 0.625rem', 
                      fontFamily: 'ITC Book, sans-serif',
                      fontSize: '0.875rem', 
                      backgroundColor: '#fff',
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      borderColor:"#76A140",
                      padding: '0rem', 
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2376A140'%3E%3Cpolygon points='12,16 6,8 18,8' /%3E%3C/svg%3E")`,
                      backgroundSize: '1.5rem',
                      backgroundPosition: 'rigth 4rem',
                      backgroundRepeat: 'no-repeat',
                    
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#6B7280', 
                    }),
                    indicatorSeparator: (base) => ({
                      backgroundColor: '#76A140', 
                      width: '1px', 
                      position: 'absolute',
                      left: '13.8rem',
                      top: '0',
                      bottom: '0', 
    
                    }),
                  }}
                />
              </div>
              <div className="flex items-center mt-4">
                <p className="px-[4%] text-[16px] font-itcbook text-[#111928]  ">Caseta:</p>
                <Select
                  value={optionsCaseta.find(option => option.value === caseta)}
                  onChange={handleChangeCaseta}
                  options={optionsCaseta}
                  placeholder="Seleccione"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#76A140', 
                      borderRadius: '0.375rem', 
                      width: '17.188rem', 
                      height: 'full',
                      padding: '0.3rem 1.25rem 0.3rem 0.625rem',
                      fontFamily: 'ITC Book, sans-serif',
                      fontSize: '0.875rem', 
                      backgroundColor: '#fff',
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      borderColor:"#76A140",
                      padding: '0rem', 
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2376A140'%3E%3Cpolygon points='12,16 6,8 18,8' /%3E%3C/svg%3E")`,
                      backgroundSize: '1.5rem',
                      backgroundPosition: 'rigth 4rem',
                      backgroundRepeat: 'no-repeat',
                    
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#6B7280', 
                    }),
                    indicatorSeparator: (base) => ({
                      backgroundColor: '#76A140', 
                      width: '1px', 
                      position: 'absolute',
                      left: '13.8rem',
                      top: '0',
                      bottom: '0', 
                    }),
                  }}
                />
              </div>
    
              <div className="flex items-center mt-4 ">
                <p className="px-[4%] text-[16px] font-itcbook text-[#111928] ">Cargo:</p>
                <Select
                  value={optionsCargo.find(option => option.value === cargo)}
                  onChange={handleChangeCargo}
                  options={optionsCargo}
                  placeholder="Seleccione"
                  styles={{
                    control: (base) => ({
                      ...base,
                      borderColor: '#76A140',
                      borderRadius: '0.375rem', 
                      width: '17.188rem', 
                      height: 'full',
                      padding: '0.3rem 1.25rem 0.3rem 0.625rem', 
                      fontFamily: 'ITC Book, sans-serif',
                      fontSize: '0.875rem', 
                      backgroundColor: '#fff', 
                    }),
                    dropdownIndicator: (base) => ({
                      ...base,
                      borderColor:"#76A140",
                      padding: '0rem',
                      backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%2376A140'%3E%3Cpolygon points='12,16 6,8 18,8' /%3E%3C/svg%3E")`,
                      backgroundSize: '1.5rem',
                      backgroundPosition: 'rigth 4rem',
                      backgroundRepeat: 'no-repeat',
                    
                    }),
                    placeholder: (base) => ({
                      ...base,
                      color: '#6B7280', 
                    }),
                    indicatorSeparator: (base) => ({
                      backgroundColor: '#76A140',
                      width: '1px', 
                      position: 'absolute',
                      left: '13.8rem',
                      top: '0',
                      bottom: '0', 
    
                    }),
                  }}
                />
              </div>
            </div>    
    
            <div className="px-[2%] mt-12 lg:ml-[9.5rem] 2xl:ml-[9.5rem] ">
              <div className="px-[4%] space-y-5">
                <p className="text-[#2F2F3B] font-itcmedium text-[20px] ">Dar accesos a:</p>
                <div className="space-y-4 " >
                  {optionsRadios.map((opt) => (
                    <div key={opt.value} className="flex items-center ">
                      <input
                        type="checkbox"
                        id={opt.value}
                        checked={selectedOptionsRadios.includes(opt.value)}
                        onChange={() => toggleOption(opt.value)}
                        className="text-[#C4C7CC] focus:ring-[#C4C7CC] rounded"
                      />
                      <label htmlFor={opt.value} className="ml-3 font-itcbook text-[14px] text-[#1B1F26B8] ">
                        {opt.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
    
              <div className="flex w-full justify-center pt-[14rem] 2xl:pt-[3rem] 2xl:py-14 md:pt-[19rem] xl:pt-[13rem] gap-8 md:space-x-3  py-12">
                    <button 
                      className="sm:px-24 px-[35px] inline-block sm:h-[64px] xl:z-10  h-[46px] md:w[310px] text-lg text-center leading-tight text-white bg-green rounded-2xl font-itcdemi">
                          Guardar
                    </button>   
                    <button className="sm:px-24 px-[35px] inline-block xl:z-10  sm:h-[64px] h-[46px]  text-lg text-center bg-white border-2 text-green rounded-2xl font-itcdemi border-green">
                          Cancelar
                    </button>                   
              </div>  
            </div>
          </div> 
          <Programate/>
        </div>
      </div>  
    </div>
  );
};

export default Configuration;
